import React from 'react';
import styled from 'styled-components';

import { ReactComponent as VideoSvg } from '../../../../assets/icons/video.svg';
import {
  OutlineButton,
  Link,
  FlexWrapper as FlexWrapperBase,
  Description as DescriptionBase
} from '../styled-components';

export { Title, Link, OutlineButton } from '../styled-components';

export const Description = styled(DescriptionBase)`
  &:last-child {
    margin-bottom: 0px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    &:last-child {
      margin-bottom: 28px;
    }
  }
`;

export const FlexWrapper = styled(FlexWrapperBase)`
  margin-bottom: 14px;

  ${Description} {
    margin-bottom: 14px;
  }

  &:last-child {
    margin-bottom: 0px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    &:last-child {
      margin-bottom: 28px;
    }
  }
`;

export const RightOutlineButton = styled(OutlineButton)`
  display: flex;
  justify-content: center;
  margin-bottom: 14px;
  height: min-content;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    margin-top: 0px;
    margin-left: 24px;
  }
`;

export const SmallOutlineButton = styled(OutlineButton)`
  display: inline-block;
  line-height: 0;
  margin-right: 24px;
  padding: 5px 10px;

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    font-size: inherit;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    margin-top: 10px;
  }
`;

export const VideoButton: React.FC<{ href: string }> = ({ href, children }) => (
  <SmallOutlineButton as="div">
    <Link href={href} target="_blank">
      <VideoSvg width={18} /> &nbsp; {children}
    </Link>
  </SmallOutlineButton>
);
